import {
  ClaimReportBuildingDamageFormData,
  ClaimReportEnterpriseFormData,
  ClaimReportGlassesFormData,
  ClaimReportLiabilityDamageFormData,
  ClaimReportMachineFormData,
  ClaimReportMotorVehicleFormData,
  ClaimReportTheftFormData
} from './ClaimModels';

export const ClaimReportLiabilityDamageReceipt = (
  formData: ClaimReportLiabilityDamageFormData
) => {
  return `<div>
      <p>
        Tak for din anmeldelse
        <br />
        Vi påbegynder skadebehandlingen og kontakter dig ved behov for
        yderligere information.
      </p>
      <br />
      <p>
        Venlig hilsen,
        <br />
        Gjensidige
      </p>
      <br />
      <div>
      Policenummer: ${formData.policyNumber}
      <br />
        Virksomhedens navn: ${formData.companyName}
        <br />
        CVR-nr: ${formData.cvrNumber}
        <br/>
        Navn (kontaktperson): ${formData.contactPersonName}
        <br />
        Telefonnummer (kontaktperson): ${formData.contactPersonPhoneNumber}
        <br/>
        Email (kontaktperson): ${formData.email}
        <br />
        Evt. referencenummer: ${formData.referenceNumber}
        <br />
        <br />
        Er nogen personer kommet til skade?: ${formData.isAnyoneInjured}
        <br />
        Hvor er skaden sket?: ${formData.damageLocation}
        <br />
        Hvad er der sket og hvordan skete det?: ${formData.damageDescription}
        <br />
        Er skaden anmeldt til skadelidtes egen forsikring?: ${formData.damageReportedOwnInsuranceCompany}
        <br />
        Har du modtaget et krav fra skadelidte? ${formData.claimFromInjuredParty}
        <br />
        Hvor stort er kravet? ${formData.claimAmount}
        <br />
        Hvilken dato har du modtaget kravet? ${formData.claimDate}
        <br />
        <br />
        Skadelidte navn: ${formData.injuredPartyName}
        <br />
        Skadelidte tlf. nr: ${formData.injuredPartyPhoneNumber}
        <br />
        Skadelidte e-mail: ${formData.injuredPartyEmail}
        <br />
        Skadelidte adresse: ${formData.injuredPartyAddress}
        <br />
        Skadelidte postnummer: ${formData.injuredPartyPostalCode}
        <br />
        Skadelidte CVR-nr: ${formData.injuredPartyCVRNumber}
      </div>
    </div>`;
};

export const ClaimReportGlassesReceipt = (
  formData: ClaimReportGlassesFormData
) => {
  return `<div>
      <p>
        Tak for din anmeldelse
        <br />
        Vi påbegynder skadebehandlingen og kontakter dig ved behov for
        yderligere information.
      </p>
      <br />
      <p>
        Venlig hilsen,
        <br />
        Gjensidige
      </p>
      <br />
      <div>
        CVR-nummer: ${formData.cvrNumber}
        <br />
        Policenummer: ${formData.policyNumber}
        <br />
        Navn (kontaktperson): ${formData.contactPersonName}
        <br />
        Email (kontaktperson): ${formData.email}
        <br />
        Telefonnummer (kontaktperson): ${formData.contactPersonPhoneNumber}
        <br />
        <br />
        Skadelidtes fulde navn: ${formData.injuredPartyName}
        <br />
        Fødselsdato: ${formData.injuredPartyDOB}
        <br />
        Skadelidtes stilling eller beskæftigelse: ${formData.injuredPartyEmployment}
        <br />
        Skadelidtes adresse: ${formData.injuredPartyAddress}
        <br />
        Er skadelidte ansat hos anmelderen? ${formData.isInjuredPartyEmployedAtReporter}
        <br />
        Hvornår skete skaden? ${formData.injuryDate}
        <br />
        Hvilket arbejde var skadelidte beskæftiget med, da skaden skete? ${formData.kindOfWorkWhenInjured}
        <br />
        Hvad var årsagen til at brillen blev beskadiget? ${formData.injuryReason}
        <br />
        Havde skadelidte brillen på, da skaden skete? ${formData.hadGlassesOn}
        <br />
        Hvornår blev den beskadigede brille købt? ${formData.dateOfPurchase}
        <br />
        Hvad var prisen oprindeligt på brillen? ${formData.originalPriceOfGlasses}
        <br />
        Anslå prisen for at anskaffe en tilsvarende brille i dag: ${formData.priceEstimate}
        <br />
        Jeg erklærer herved, at foranstående oplysninger er i overensstemmelse
        med de faktiske forhold, og at jeg vil yde selskabet enhver assistance i
        forbindelse med skaden.: ${formData.consent}
      </div>
    </div>`;
};

export const ClaimReportBuildingReceipt = (
  formData: ClaimReportBuildingDamageFormData
) => {
  return `<div>
        <p>
          Tak for din anmeldelse
          <br />
          Vi påbegynder skadebehandlingen og kontakter dig ved behov for
          yderligere information.
        </p>
        <br />
        <p>
          Venlig hilsen,
          <br />
          Gjensidige
        </p>
        <br />
        <div>
          CVR-nummer: ${formData.cvrNumber}
          <br />
          Policenummer: ${formData.policyNumber}
          <br />
          Navn (kontaktperson): ${formData.contactPersonName}
          <br />
          Email (kontaktperson): ${formData.email}
          <br />
          Telefonnummer (kontaktperson): ${formData.contactPersonPhoneNumber}
          <br/><br/>
          Telefonnummer til ejendomsinspektør: ${formData.propertyInspectorPhoneNumber}
          <br/>
          Adresse på den skadesramte ejendom: ${formData.damagedPropertyAddress}<br/>
          Er ejendommen momsregistreret? ${formData.isPropertyVATRegistered}<br/>
          Ejendommens type: ${formData.propertyType}<br/>
          Den skadesramte bygning anvendes til: ${formData.propertyUse}<br/>
          Er der også tegnet forsikring i et andet selskab? ${formData.insuredByOther}<br/>
          Hvilket selskab? ${formData.insuranceCompanyDetails}<br/>
          Hvordan skete skaden og hvad har forårsaget den? ${formData.damageDetails}<br/>
          Hvilke forsikringsgenstande (bygningsdele og/eller installationer) er beskadiget - og i hvilket omfang? ${formData.insuranceItemsDamageDetails}<br/>
          Hvornår skete skaden? ${formData.damageDate}<br/>
          Hvornår blev skaden opdaget? ${formData.damageDiscovered}<br/>
          Er andre skyld i skaden? ${formData.othersToBlame}<br/>
          Hvem? ${formData.whoToBlame}<br/>
          Hvilken skade er sket? ${formData.typeOfDamage}<br/>
          Udfyld kun hvis glasskade: Beskriv den beskadigede rude: ${formData.glassDamageDetails}<br/>
          Udfyld kun hvis tyveri: Beskriv skaden: ${formData.theftDamageDetails}<br/>
          Udfyld kun hvis skade på sanitet: Beskriv skaden: ${formData.sanitationDamdageDetails}<br/>
          Udfyld kun hvis skade på gulvtæppe: Beskriv skaden: ${formData.carpetDamageDetails}<br/>
          Hvem kan udbedre skaden? ${formData.repairDamagePerson}<br/>
          Overslag for udbedring i kroner: ${formData.priceRepairEstimate}<br/>
          Jeg erklærer herved, at foranstående oplysninger er i overensstemmelse med de faktiske forhold, og at jeg vil yde selskabet enhver assistance i forbindelse med skaden: ${formData.consent}
        </div>
      </div>`;
};

export const ClaimReportEnterpriseReceipt = (
  formData: ClaimReportEnterpriseFormData
) => {
  return `<div>
        <p>
          Tak for din anmeldelse
          <br />
          Vi påbegynder skadebehandlingen og kontakter dig ved behov for
          yderligere information.
        </p>
        <br />
        <p>
          Venlig hilsen,
          <br />
          Gjensidige
        </p>
        <br />
        <div>
          CVR-nummer: ${formData.cvrNumber}
          <br />
          Policenummer: ${formData.policyNumber}
          <br />
          Navn (kontaktperson): ${formData.contactPersonName}
          <br />
          Email (kontaktperson): ${formData.email}
          <br />
          Telefonnummer (kontaktperson): ${formData.contactPersonPhoneNumber}
          <br />
          <br />
          Skadevolders adresse: ${formData.defendantsAddress}
          <br />
          Skadevolders stilling og navn: ${formData.defendantsEmploymentAndName}
          <br />
          Skadevolders CVR-nummer: ${formData.defendantsCVRNumber}
          <br />
          <br />
          Skadelidtes stilling og navn: ${formData.victimsEmploymentAndName}
          <br />
          Skadelidtes adresse: ${formData.victimsAddress}
          <br />
          Skadelidtes telefonnummer: ${formData.victimsPhoneNumber}
          <br />
          Står skadelidte i tjenesteforhold til skadevolder? ${formData.isVictimInEmploymentWithDefendant}
          Hvilket forhold? ${formData.typeofRelationship}
          <br />
          <br />
          Hvornår skete skaden? ${formData.damageDate}
          <br />
          Hvor skete skaden? ${formData.damageLocation}
          <br />
          Under hvilke omstændigheder skete skaden? ${formData.damageOccuredCircumstances}
          <br />
          Beskriv skadens omfang: ${formData.extentOfDamage}
          <br />
          Hvilke erstatningskrav er fremsat? ${formData.claimsMade}
          <br />
          Hvilket beløb anslår du skaden til? ${formData.priceEstimateDamage}
          <br />
          Havde forsikrede det beskadigede til lån, afbenyttelse, befordring eller
          bearbejdelse (reparation)? ${formData.wasPropertyForLoanTransportationProcessing}
          Hvordan? ${formData.propertyUsedForDetails}
          Hvem mener du bærer skylden for skaden og hvorfor? ${formData.whoToBlameAndWhy}
          <br />
          <br />
          Er der optaget politirapport? ${formData.policeReportMade}
          <br />
          Hvilken politistation? ${formData.policeStation}
          <br />
          Har Arbejdstilsynet været involveret? ${formData.arbejdstilsynetInvolved}
          <br />
          Var der vidner til skadehændelsen? ${formData.witnesses}
          <br />
          Har skadelidte anmeldt skaden til eget forsikringsselskab?: ${formData.reportedToOwnInsuranceCompany}
          <br />I hvilket selskab er skadelidte forsikret? ${formData.insuranceCompanyName}
          <br />
          Hvad er skadelidtes policenummer? ${formData.victimsPolicyNumber}
          <br />
          Hvis skade på køretøj: Er køretøjet forsikret med kaskoforsikring? ${formData.hasMotorVehicleKasko}
          <br />
          Hvis køretøj, noter evt. registreringsnummer på det beskadigede køretøj:
          ${formData.motorVehicleRegistrationNumber}
          <br />
          Jeg erklærer herved, at foranstående oplysninger er i overensstemmelse
          med de faktiske forhold, og at jeg vil yde selskabet enhver assistance i
          forbindelse med skaden.: ${formData.consent}
        </div>
      </div>`;
};

export const ClaimReportMachineReceipt = (
  formData: ClaimReportMachineFormData
) => {
  return `<div>
        <p>
          Tak for din anmeldelse
          <br />
          Vi påbegynder skadebehandlingen og kontakter dig ved behov for
          yderligere information.
        </p>
        <br />
        <p>
          Venlig hilsen,
          <br />
          Gjensidige
        </p>
        <br />
        <div>
          CVR-nummer: ${formData.cvrNumber}
          <br />
          Policenummer: ${formData.policyNumber}
          <br />
          Navn (kontaktperson): ${formData.contactPersonName}
          <br />
          Email (kontaktperson):  ${formData.email}
          <br />
          Telefonnummer (kontaktperson):  ${formData.contactPersonPhoneNumber}
          Hvor er skaden sket? ${formData.damageAddress}
          <br />
          <br />
          Tilhører den beskadigede maskine din virksomhed?:  ${formData.machineBelongsToCompany} <br />
          Hvis nej, hvem tilhører maskinen?:  ${formData.machineBelongsTo}
          <br />
          Hvornår skete skaden?:  ${formData.damageDate} <br />
          Fabrikat:  ${formData.product} <br />
          Type:  ${formData.productType} <br />
          Stelnummer: { ${formData.productChassisNumber}} <br />
          Årgang:  ${formData.productYearModel}
          <br />
          Positionsnr. på policen:  ${formData.productPositionNumberOnPolicy}
          <br />
          Hvori består skaden og hvad var årsagen?:  ${formData.damageDetailsAndCause}<br />
          <br />
          Hvem passede maskinen, da skaden indtraf?:  ${formData.machineCaretakerDamageOccured} <br />
          Kan maskinen repareres på stedet eller skal dele af den på
          specialværksted?:  ${formData.machineRepairOnSiteOrSpecialWorkshop} <br />
          Hvem skal foretage reparationen?:  ${formData.whoRepairsMachine} <br />
          Har maskinen tidligere været repareret?:  ${formData.machinePreviouslyRepaired} <br />
          Er der tegnet forsikring mod samme skade i et andet selskab?: ${formData.insuredByOthers}
          <br />
          Hvis ja, hvilket selskab og for hvilken sum?:  ${formData.insuranceCompanyNameAndAmount} <br />
          Hvor længe antages reparationen at tage?:  ${formData.estimateRepairTime} <br />
          <br />
          Værkstedets navn og adresse:  ${formData.workshopNameAndAddress}
          <br />
          <br />
          Værkstedets prisoverslag:  ${formData.workshopPriceEstimate} <br />
          Evt. eget overslag:  ${formData.ownPriceEstimate} <br />
          Jeg erklærer herved, at foranstående oplysninger er i overensstemmelse
          med de faktiske forhold, og at jeg vil yde selskabet enhver assistance i
          forbindelse med skaden.:  ${formData.consent}
        </div>
      </div>`;
};

export const ClaimReportMotorVehicleReceipt = (
  formData: ClaimReportMotorVehicleFormData
) => {
  return `<div>
        <p>
          Tak for din anmeldelse
          <br />
          Vi påbegynder skadebehandlingen og kontakter dig ved behov for
          yderligere information.
        </p>
        <br />
        <p>
          Venlig hilsen,
          <br />
          Gjensidige
        </p>
        <br />
        <div>
          Virksomhedens navn: ${formData.companyName}
          <br />
          CVR-nummer: ${formData.cvrNumber}
          <br />
          Navn (kontaktperson): ${formData.contactPersonName}
          <br />
          Email (kontaktperson): ${formData.email}
          <br />
          Telefonnummer (kontaktperson): ${formData.contactPersonPhoneNumber}
          <br />
          Er motorkøretøjet indregistreret? ${formData.isMotorVehicleRegistered}
          <br />
          Registreringsnummer: ${formData.registrationNumber}
          <br />
          Stelnummer / motornummer: ${formData.chassisNumber}
          <br />
          Fabrikat og type: ${formData.productAndType}
          <br />
          Årgang: ${formData.yearModel}
          <br />
          Har du abonnement hos et redningskorps? ${formData.rescueCorpSubscription}
          <br />
          Anvendelse i skadesøjeblikket: ${formData.useAtTimeOfDamage}
          <br />
          Indgår køretøjet i en momsregistreret virksomhed? ${formData.vehiclePartOfVATCompany}
          <br />
          <br />
          Beskriv skaden så udførligt som muligt: ${formData.damageDetails}
          <br />
          Dato og tidspunkt for skaden: ${formData.damageDateAndTime}
          <br />
          Skadestedets adressse: ${formData.sceneOfAccidentAddress}
          <br />
          Blev der optaget politirapport? ${formData.policeReportMade}
          <br />
          Til hvilken politistation? ${formData.policeStation}
          <br />
          Blev føren af dit køretøj aloholtestet (ballon?): ${formData.driverTookAlcoholTest}
          <br />
          Blev føren af dit køretøj spiritustestet (blodprøve)? ${formData.driverTookBloodTest}
          <br />
          Førers navn og adresse: ${formData.driversNameAndAddress}
          <br />
          Telefonnummer på føreren: ${formData.driversPhoneNumber}
          <br />
          Havde føren gyldigt kørekort på skadestidspunktet? ${formData.driverHadValidDriversLicense}
          <br />
          Kørekortnummer: ${formData.driversLicenseNumber}
          <br />
          Udstedelsesdato: ${formData.driversLicenseDateOfIssue}
          <br />
          Kørekorttype: ${formData.driversLicenseType}
          <br />
          Din hastighed (km/t): ${formData.speedOfVehicle}
          <br />
          Var dine lygter tændt? ${formData.wereLightsOn}
          <br />
          Var gadebelysningen tændt? ${formData.wereStreetLightsOn}
          <br />
          Var uheldsstedet oplyst i øvrigt? ${formData.accidentSiteInformed}
          <br />
          Hvordan var vejret og føret? ${formData.weatherAndDrivingConditions}
          <br />
          Er der skader på dit køretøj? ${formData.isVehicleDamaged}
          <br />
          Var der en modpart? ${formData.wasThereOtherParty}
          <br />
          Hvor kom modparten fra? ${formData.otherPartyComeFrom}
          <br />
          Udfyld med information om modparten: ${formData.otherPartyDetails}
          <br />
          Blev modpartens køretøj beskadiget? ${formData.otherPartyVehicleDamaged}
          <br />
          Beskriv skaderne på modpartens køretøj? ${formData.otherPartyVehicleDamageDetails}
          <br />
          Modpartens hastighed (km/t): ${formData.otherPartySpeed}
          <br />
          Var modpartens lygter tændt? ${formData.otherPartyLightsOn}
          <br />
          Hvem er efter din mening skyld i uheldet? ${formData.whoToBlame}
          <br />
          <br />
          Var der vidner til skaden? ${formData.witnessToAccident}
          <br />
          Hvor befandt vidnet sig? ${formData.witnessLocation}
          <br />
          Beskriv vidnets placering og evt. kontaktinformation: ${formData.witnessOtherLocation}
          <br />
          Skete der skade på en person? ${formData.personInjured}
          <br />
          Beskriv hvem der er kommet til skade og hvordan? ${formData.personInjuredDetails}
          <br />
          Hvis der skete skade på andet, kan du beskrive det her: ${formData.damageOnOtherProperties}
          <br />
          Jeg erklærer herved, at foranstående oplysninger er i overensstemmelse
          med de faktiske forhold, og at jeg vil yde selskabet enhver assistance i
          forbindelse med skaden.: ${formData.consent}
        </div>
      </div>`;
};

export const ClaimReportTheftReceipt = (formData: ClaimReportTheftFormData) => {
  return `<div>
        <p>
          Tak for din anmeldelse
          <br />
          Vi påbegynder skadebehandlingen og kontakter dig ved behov for
          yderligere information.
        </p>
        <br />
        <p>
          Venlig hilsen,
          <br />
          Gjensidige
        </p>
        <br />
        <div>
          Virksomhedens navn: ${formData.companyName}
          <br />
          CVR-nummer: ${formData.cvrNumber}
          <br />
          Policenummer: ${formData.policyNumber}
          <br />
          Navn og stilling (kontaktperson): ${formData.contactPersonNameAndEmployment}
          <br />
          Email (kontaktperson): ${formData.email}
          <br />
          Telefonnummer (kontaktperson): ${formData.contactPersonPhoneNumber}
          <br />
          <br />
          Tyveriet skete fra: ${formData.theftLocation}
          <br />
          Skadestedets adresse: ${formData.sceneOfAccidentAddress}
          <br />
          Tidspunkt for tyveri: ${formData.timeOfAccident}
          <br />
          Hvornår blev tyveriet opdaget? ${formData.theftDiscovered}
          <br />
          Hvordan mener du, tyveriet er foregået? ${formData.theftDetails}
          <br />
          Hvis relevant: Var bilen forsvarligt aflåst? ${formData.carSecurelyLocked}
          <br />
          Hvis relevant: Var alle vinduer helt lukkede? ${formData.windowsClosed}
          <br />
          Hvis relevant: Blev tyverialarmen aktiveret? ${formData.alarmActivated}
          <br />
          Hvornår blev tyveriet anmeldt til politiet? ${formData.theftReportedDate}
          <br />
          Til hvilken politistation? ${formData.policeStation}
          <br />
          Hvem anmeldte skaden? ${formData.whoReportedDamage}
          <br />
          Tilhører de stjålne/beskadigede genstande forsikringstageren? ${formData.stolenItemsBelongToPolicyholder}
          <br />
          Hvem tilhører de? ${formData.stolenItemsBelongToOther}
          <br />
          Er der tegnet en forsikring mod samme skade hos noget andet selskab? ${formData.insuredByOthers}
          <br />
          Hvilket forsikringsselskab? ${formData.insuranceCompanyName}
          <br />
          <br />
          Angiv det totale erstatningskrav: ${formData.totalClaim}
          <br />
          Jeg erklærer herved, at foranstående oplysninger er i overensstemmelse
          med de faktiske forhold, og at jeg vil yde selskabet enhver assistance i
          forbindelse med skaden.: ${formData.consent}
        </div>
      </div>`;
};
